<template>
    <div class="m-stepper-object-edit container">
        <m-form-object-types ref="objecttypes" :objectTypeId="objectTypeModel" @form:submit="nextStep"
                             @form:cancel="cancel"/>
        <m-form-object ref="objectdata" :objectTypeId="objectTypeModel" :object="object" @form:submit="submit"
                       @form:cancel="cancelForm"/>
        <m-form-object-trades ref="objecttrades" @form:submit="submit" @form:cancel="cancelForm"/>
        <m-block-form-buttons
                :isLoading="$wait.waiting(keys.objects.create)"
                context="default"
                :text="buttonsText"
                :showCancelButton="false"
                @submit="save"
        ></m-block-form-buttons>
    </div>
</template>

<script>
    import mFormObject from "@modules/forms/concrete/objects/m-form-object";
    import MStepperBase from "@modules/steppers/m-stepper-base";
    import MStepperContent from "@modules/steppers/includes/_m-stepper-content";
    import MBlockFormButtons from "@modules/blocks/buttons/concrete/m-block-form-buttons";
    import {mapActions, mapGetters} from 'vuex';
    import vuexKeys from '@mixins/includes/_vuexKeys';
    import dialogs from '@mixins/includes/_dialogs';
    import notifications from '@/mixins/includes/_notifications';
    import isEmpty from 'lodash/isEmpty'
    import MForm from "@modules/forms/m-form";
    import MBlockFormFields from "@modules/blocks/form/m-block-form-fields";
    import MFormObjectTrades from "@modules/forms/concrete/objects/m-form-object-trades";
    import MFormObjectTypes from "@modules/forms/concrete/objects/m-form-object-types";
    import pick from 'lodash/pick'

    export default {

        name: "m-stepper-object-edit",
        components: {
            MBlockFormFields,
            MForm,
            MBlockFormButtons,
            MStepperContent,
            MStepperBase,
            mFormObject,
            MFormObjectTrades,
            MFormObjectTypes
        },
        mixins: [vuexKeys, dialogs, notifications],
        data: function () {
            return {
                steps: [
                    {
                        title: this.$t('modules.steppers.m-stepper-object-create.step-1.title')
                    }, {
                        title: this.$t('modules.steppers.m-stepper-object-create.step-2.title')
                    },
                    {
                        title: this.$t('modules.steppers.m-stepper-object-create.step-3.title')
                    }
                ],
                step: 1,
                objectTypeModel: '',
                data: {}
            }
        },
        mounted() {
            this.objectTypeModel = this.objectTypeId;
        },
        computed: {
            ...mapGetters({
                getObject: 'objects/read',
                getObjectType: 'objectTypes/read'
            }),
            isEmptyObject() {
                return isEmpty(this.object);
            },
            object() {
                return this.getObject(this.$route.params.id);
            },
            objectType() {
                return this.getObjectType(this.objectTypeId)
            },
            objectTypeId() {
                return this.object._jv.relationships.objectType.data.id
            },
            isObjectTypeChanged() {
                return this.objectTypeId !== this.objectTypeModel
            },
            buttonsText() {
                return {
                    submit: this.$t('modules.forms.m-form-object-edit.save')
                }
            }
        },
        methods: {
            ...mapActions({
                loadObject: 'objects/read',
                updateObject: 'objects/update'
            }),
            requestObject() {
                return this.loadObject({
                    id: this.$route.params.id
                });
            },
            async submitForm(data) {
                let payload = this.prepareFormData(data);
                // TODO temporary
                delete payload.metadata;
                try {
                    let object = await this.updateObject(payload);
                    this.notify.success(this.$t('notifications.objects.edited', {name: object.name}))
                    this.redirect(this.nav.dashboard.service.objects.view.name, {id: object._id})
                } catch (e) {
                    //
                }
            },
            prepareFormData(data) {
                data = this.addExtraData(data);
                return data;
            },

            addExtraData(data) {
                // if (!this.isObjectTypeChanged) return data;
                let formData = data
                if (!formData._jv) {
                    Object.assign(formData, this.object)
                }
                formData._jv.relationships.objectType = {
                    data: {type: this.keys.objectTypes.key, id: this.objectTypeModel}
                };

                if (!isEmpty(formData.businessTypes)) {
                    let businessTypes = formData.businessTypes.map((i) => pick(i._jv, ['id', 'type']));

                    formData._jv.relationships.businessType = {
                        data: businessTypes
                    };
                }

                if (!isEmpty(formData.moderators)) {
                    let moderators = formData.moderators.map((i) => pick(i._jv, ['id', 'type']));

                    formData._jv.relationships.moderators = {
                        data: moderators
                    };
                } else {
                    formData._jv.relationships.moderators = {
                        data: formData.moderators
                    };
                }

                return formData;
            },
            cancel() {
                this.goBack()
            },
            cancelForm() {
                this.$refs.stepper.prevStep()
            },
            nextStep(data) {
                if (data && data.objectTypeId) {
                    this.objectTypeModel = data.objectTypeId
                }
                if (this.step == 1) {
                    if (this.isObjectTypeChanged) {
                        this.openDialog('objectTypeChanged').then((confirmed) => {
                            if (!confirmed) return;
                            this.step = 2;
                            this.$refs.objectdata.submit();
                        })
                    } else {
                        this.step = 2;
                        this.$refs.objectdata.submit();
                    }
                } else if (this.step == 2) {
                    this.step++;
                    this.$refs.objecttrades.submit();
                } else {
                    this.step = 1;
                }
            },
            submit(data) {
                if (this.step === 2) {
                    Object.assign(this.data, data)
                    this.nextStep()
                } else if (this.step === 3) {
                    Object.assign(this.data, data)
                    this.submitForm(this.data)
                }
            },
            async save() {
                await this.$refs.objecttypes.submit();
            },
        }
    }
</script>

<style lang="scss">
    .m-stepper-object-edit {
        background: var(--v-white) !important;
        padding: 1rem;
        margin-top: 1rem;
        padding-top: 0;
        border-radius: 3px;
        -webkit-box-shadow: 0px 1px 6px 0px rgba(0, 73, 148, 0.61) !important;
        box-shadow: 0px 1px 6px 0px rgba(0, 73, 148, 0.61) !important;

        .m-stepper__header-container {
            display: none;
        }

        .m-stepper-content {
            padding-top: .5rem;
        }
    }
</style>
